import { gql } from "@apollo/client"

const UPDATE_CLIENT_SETTINGS_MUTATION = gql`
  mutation($client_id: ID!, $input: UpdateClientSettingInput!) {
    updateClientSetting(client_id: $client_id, input: $input) {
      id
      client_id
      unbook_on_non_attendance
      logo_background_color
      phone
      email
      allow_parent_notes
      allow_parent_waiting_list
      allow_teacher_availability
      allow_teacher_bookings
      allow_teacher_reports
      require_legal_guardian
    }
  }
`

export { UPDATE_CLIENT_SETTINGS_MUTATION }
